module.exports = __webpack_public_path__ + "img/Resources & Materials Allocation.4cf7f6d0.jpg";